import React, { Component } from 'react'
import { Modal, Descriptions } from 'antd'
import moment from 'moment'
import LangContext from 'modules/shared/context/langContext'

class LccCauseDetailModal extends Component {
  render() {
    const { visible, record, onCancel } = this.props

    const cause = record && record.lcc_cause ? record.lcc_cause : {}
    const updatedBy = cause.updated_by || {}
    const recorderName = updatedBy.username
      ? updatedBy.username
      : `${updatedBy.firstname || ''} ${updatedBy.lastname || ''}`.trim()

    const updatedAt = cause.updated_at
      ? moment(cause.updated_at).format('DD/MM/YYYY HH:mm')
      : '-'

    return (
      <LangContext.Consumer>
        {i18n => (
          <Modal
            visible={visible}
            title={i18n.r.recordTheReason}
            onCancel={onCancel}
            footer={null}
          >
            <Descriptions column={1} bordered size="small">
              <Descriptions.Item label={i18n.r.reason}>
                {cause.name || '-'}
              </Descriptions.Item>
              <Descriptions.Item label={i18n.n.note}>
                {cause.note || '-'}
              </Descriptions.Item>
              <Descriptions.Item label={i18n.u.updated_by}>
                {recorderName}
              </Descriptions.Item>
              <Descriptions.Item label={i18n.u.updatedAt}>
                {updatedAt}
              </Descriptions.Item>
            </Descriptions>
          </Modal>
        )}
      </LangContext.Consumer>
    )
  }
}

export default LccCauseDetailModal
